import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { IonApp, IonRouterOutlet, IonBadge, IonIcon } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';
import { addIcons } from 'ionicons';
import {
  add,
  alertCircle,
  alertCircleOutline,
  bedOutline,
  calendarOutline,
  hammerOutline,
  cashOutline,
  chatbubbleOutline,
  chevronBack,
  chevronBackOutline,
  chevronForwardOutline,
  close,
  closeCircle,
  cubeOutline,
  downloadOutline,
  exitOutline,
  eyeOffOutline,
  eyeOutline,
  gridOutline,
  homeOutline,
  listOutline,
  lockClosedOutline,
  logInOutline,
  logOutOutline,
  mailOutline,
  medicalOutline,
  medkitOutline,
  people,
  peopleOutline,
  personOutline,
  searchOutline,
  searchSharp,
  personAddSharp,
  logOutSharp,
  callOutline,
  personAddOutline,
  notificationsOutline,
  trashOutline,
  createOutline,
  settingsOutline,
  starOutline,
  wifi,
  wifiOutline,
  calendarNumber,
  flash,
  medkit,
  chevronDownCircleOutline,
  documentText,
  pencilOutline,
  chevronDown,
  chevronUp,
  documentTextSharp,
  documentTextOutline,
  nutritionOutline,
  restaurantOutline,
  chevronUpOutline,
  chevronDownOutline,
  folderOutline,
  ellipse,
  ellipseOutline,
  flaskOutline,
  remove,
  shieldOutline,
  cardOutline,
  receiptOutline,
  analyticsOutline,
  personCircleOutline,
  listCircleOutline,
  businessOutline,
  cogOutline,
  image,
  imageOutline,
  documentOutline,
  timeOutline,
  checkboxOutline,
  keyOutline,
  videocamOutline,
  addCircleOutline,
  today,
  todayOutline,
  calendarNumberOutline,
  statsChartOutline,
  barChartOutline,
  accessibilityOutline,
  bookOutline,
  leafOutline,
  beakerOutline,
  clipboardOutline,
  womanOutline,
  manOutline,
  chevronForward,
  ellipsisVerticalOutline,
  addOutline,
  save,
  saveOutline,
  checkmarkCircleOutline,
  checkmarkCircle,
  closeCircleOutline,
  closeOutline,
  refreshOutline,
  arrowBack,
  arrowForward,
  calendar,
  locationOutline,
  ban,
  checkmarkOutline,
  femaleOutline,
  maleOutline,
  reorderThreeSharp,
  reorderThreeOutline,
  settings,
  settingsSharp,
  checkmarkCircleSharp,
  eyeSharp,
  swapVerticalSharp,
  peopleCircleOutline,
  newspaperOutline,
  swapHorizontal,
  swapHorizontalOutline,
  shareOutline,
  constructOutline,
  barcodeOutline,
  arrowBackOutline,
  cloudUploadOutline,
  grid,
  filterSharp,
  refresh,
  checkmarkDone,
  eyeOff,
  eye,
  banOutline,
  playOutline,
  hardwareChipOutline,
  toggleOutline,
  textOutline,
  cameraOutline,
  calculatorOutline,
  cloudDownloadOutline,
  ellipsisVertical,
  ellipsisVerticalCircle,
  warning,
  create,
  checkmark,
  download,
  logoWhatsapp,
  imagesOutline,
  cloudUpload,
  videocam,
  folderOpen,
  images,
  time,
  trash,
  eyedropOutline,
  reorderTwo,
  swapVertical,
  informationCircle,
  informationCircleOutline,
  removeCircleOutline,
} from 'ionicons/icons';
import { filter, Subscription } from 'rxjs';
import { version } from './commons/constants';
import { Observable } from 'rxjs';
import { IUser } from './commons/interfaces';
import { AuthService } from './auth/auth.service';
import { StateService } from '@services/state.service';
import { MenuComponent, MenuItem } from '@components/menu/menu.component';
import { MenuService } from '@services/menu.service';
import { SessionService } from '@services/session.service';
import { NetworkService } from '@services/network.service';
import { PhotoSyncService } from '@services/photo-sync.service';
import { WebStorageService } from '@services/storage/web-storage.service';
import { TestingPlatformService } from '@services/testing-platform.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    IonIcon,
    // IonBadge,
    // IonBadge,
    // IonChip,
    CommonModule,
    IonApp,
    // IonIcon,
    IonRouterOutlet,
    // RouterLink,
    // RouterLinkActive,
    MenuComponent,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  public selectedPath = '';
  public menuItems: MenuItem[] = [];
  public menuExpanded = false;
  public isMobile = false;
  public version = version;
  public isLogin: boolean = false;
  public isOnline: boolean = true;
  public user$: Observable<IUser | null>;
  public userRole: string = 'médico';

  private userSubscription!: Subscription;
  private authStateSubscription!: Subscription;
  private subscriptions = new Subscription();

  // Información del usuario
  public userProfile = {
    name: '',
    email: '',
    avatar: 'assets/avatar.svg',
    role: '',
  };

  constructor(
    private networkService: NetworkService,
    private photoSyncService: PhotoSyncService,
    private storageService: WebStorageService,
    private router: Router,
    private authService: AuthService,
    private sessionService: SessionService,
    private stateService: StateService,
    private menuService: MenuService,
    private testingPlatformService: TestingPlatformService,
  ) {
    this.user$ = this.authService.user$;

    // Detectar si está en móvil
    this.checkScreenSize();

    // Registrar todos los iconos que se usarán en la aplicación
    this.registerIcons();
  }

  private registerIcons() {
    addIcons({
      accessibilityOutline,
      add,
      addCircleOutline,
      alertCircle,
      removeCircleOutline,
      reorderTwo,
      swapVertical,
      informationCircle,
      informationCircleOutline,
      alertCircleOutline,
      analyticsOutline,
      beakerOutline,
      bedOutline,
      bookOutline,
      businessOutline,
      calendarNumber,
      calendarNumberOutline,
      calendarOutline,
      hammerOutline,
      newspaperOutline,
      callOutline,
      cardOutline,
      cashOutline,
      chatbubbleOutline,
      checkboxOutline,
      chevronBack,
      chevronBackOutline,
      chevronDown,
      chevronDownCircleOutline,
      chevronDownOutline,
      chevronForwardOutline,
      chevronUp,
      chevronUpOutline,
      clipboardOutline,
      close,
      closeCircle,
      cogOutline,
      createOutline,
      cubeOutline,
      documentOutline,
      documentText,
      documentTextOutline,
      documentTextSharp,
      downloadOutline,
      ellipse,
      ellipseOutline,
      exitOutline,
      eyeOffOutline,
      eyeOutline,
      flash,
      flaskOutline,
      folderOutline,
      gridOutline,
      homeOutline,
      imageOutline,
      keyOutline,
      leafOutline,
      listCircleOutline,
      listOutline,
      lockClosedOutline,
      logInOutline,
      logOutOutline,
      logOutSharp,
      mailOutline,
      medicalOutline,
      medkit,
      medkitOutline,
      notificationsOutline,
      nutritionOutline,
      people,
      pencilOutline,
      peopleOutline,
      personAddOutline,
      personAddSharp,
      personCircleOutline,
      personOutline,
      receiptOutline,
      remove,
      restaurantOutline,
      searchOutline,
      searchSharp,
      settingsOutline,
      shieldOutline,
      starOutline,
      statsChartOutline,
      timeOutline,
      todayOutline,
      trashOutline,
      videocamOutline,
      wifi,
      wifiOutline,
      womanOutline,
      manOutline,
      chevronForward,
      ellipsisVerticalOutline,
      addOutline,
      save,
      saveOutline,
      checkmarkCircle,
      checkmarkCircleOutline,
      closeCircleOutline,
      closeOutline,
      refreshOutline,
      arrowBack,
      arrowForward,
      calendar,
      locationOutline,
      ban,
      banOutline,
      checkmarkOutline,
      femaleOutline,
      maleOutline,
      reorderThreeSharp,
      reorderThreeOutline,
      settings,
      settingsSharp,
      checkmarkCircleSharp,
      eyeSharp,
      swapVerticalSharp,
      swapHorizontalOutline,
      peopleCircleOutline,
      shareOutline,
      constructOutline,
      barcodeOutline,
      arrowBackOutline,
      cloudUploadOutline,
      cloudDownloadOutline,
      grid,
      filterSharp,
      refresh,
      checkmarkDone,
      eyeOff,
      eye,
      eyedropOutline,
      warning,
      playOutline,
      hardwareChipOutline,
      toggleOutline,
      textOutline,
      cameraOutline,
      calculatorOutline,
      ellipsisVertical,
      ellipsisVerticalCircle,
      create,
      checkmark,
      download,
      logoWhatsapp,
      imagesOutline,
      videocam,
      folderOpen,
      images,
      time,
      cloudUpload,
      trash,
    });
  }

  @HostListener('window:resize')
  checkScreenSize() {
    this.isMobile = window.innerWidth < 768;
    // Si cambia a móvil, contraer el menú
    if (this.isMobile) {
      this.menuExpanded = false;
    }
  }

  /**
   * ⭐ NUEVO: Inicializa servicios críticos al inicio
   */
  async initializeApp(): Promise<void> {
    try {
      console.log('🚀 Inicializando aplicación...');

      // 1. Inicializar storage (PRIMERO)
      await this.storageService.initialize();
      console.log('✅ Storage inicializado');

      // 2. Inicializar detección de red
      this.networkService.getOnlineStatus().subscribe((isOnline) => {
        this.isOnline = isOnline;
        console.log(`🌐 Estado de red: ${isOnline ? 'Online' : 'Offline'}`);
      });

      // 3. Iniciar auto-sync de fotos
      this.photoSyncService.startAutoSync();
      console.log('✅ Auto-sync de fotos iniciado');

      console.log('✅ Aplicación inicializada correctamente');
    } catch (error) {
      console.error('❌ Error inicializando aplicación:', error);
    }
  }

  ngOnInit() {
    // Suscribirse a los cambios en el estado de autenticación
    this.subscriptions.add(
      this.authService.authStateChanged.subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          // Obtener los datos del usuario actual
          const user = this.authService.getUserFromStorage();
          // Actualizar el servicio de estado con el usuario
          this.stateService.setCurrentUser(user);

          // Determinar el rol del usuario y asignar el menú correspondiente
          this.updateMenuByRole();
        } else {
          // Limpiar el estado cuando el usuario cierra sesión
          this.stateService.clearState();
          this.menuItems = []; // Menú vacío si no hay sesión
        }
      }),
    );

    // Suscribirse a los cambios en el estado de autenticación
    this.authStateSubscription = this.authService.authStateChanged.subscribe((isAuthenticated) => {
      this.isLogin = isAuthenticated;

      // Actualizar timestamp cuando cambia el estado de autenticación
      this.sessionService.updateLastActivity();
    });

    // Suscribirse a los cambios del usuario
    this.userSubscription = this.user$.subscribe((user) => {
      this.isLogin = !!user;

      // Si hay un usuario, actualiza la información del perfil
      if (user) {
        // Encontrar el rol principal del usuario
        let displayRole = 'Usuario';
        if (user.roles && user.roles.length > 0) {
          const mainRole = user.roles[0]; // O cualquier lógica para determinar el rol principal
          displayRole = mainRole.display_name || mainRole.name || 'Usuario';
        }

        this.userProfile = {
          name: user.name || 'Usuario',
          email: user.email || '',
          avatar: (user.photoURL as string) || user.photo_url || this.userProfile.avatar,
          role: displayRole,
        };

        // Actualizar el menú según el rol
        this.updateMenuByRole();
      }
    });

    // Verificar el estado inicial de autenticación
    this.isLogin = this.authService.isLoggedIn();
    if (this.isLogin) {
      this.updateMenuByRole();
    }

    // Actualizar ruta seleccionada cuando cambia la navegación
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      this.selectedPath = event.url;

      // En dispositivos móviles, contraer el menú después de la navegación
      if (this.isMobile) {
        this.menuExpanded = false;
      }

      // Mostrar notificación de plataforma de pruebas al navegar
      this.testingPlatformService.showTestingPlatformNotice();
    });

    // Establecer la ruta inicial
    this.selectedPath = this.router.url || '/welcome';

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.sessionService.checkSession();
    });

    // ⭐ CAMBIO: Inicializar servicios críticos
    this.initializeApp();

    // Mostrar notificación de plataforma de pruebas al iniciar
    this.testingPlatformService.showTestingPlatformNotice();
  }
  @HostListener('document:click')
  @HostListener('document:touchstart')
  @HostListener('document:keydown')
  async onUserInteraction() {
    if (this.isLogin) {
      // Actualizar timestamp en cada interacción
      await this.sessionService.checkSession();
      this.sessionService.updateLastActivity();
    }
  }

  // Método para actualizar el menú según el rol del usuario
  private updateMenuByRole() {
    const user = this.authService.getUserFromStorage();
    if (user && user.roles && user.roles.length > 0) {
      // Buscar el primer rol disponible
      let mainRole = null;
      let roleName = '';

      // Primero intentamos encontrar roles específicos en orden de prioridad
      if (user.roles.some((r) => r.name === 'admin')) {
        mainRole = user.roles.find((r) => r.name === 'admin');
        roleName = 'admin';
      } else if (user.roles.some((r) => r.name === 'nutritionist')) {
        mainRole = user.roles.find((r) => r.name === 'nutritionist');
        roleName = 'nutritionist';
      } else if (user.roles.some((r) => r.name === 'doctor')) {
        mainRole = user.roles.find((r) => r.name === 'doctor');
        roleName = 'doctor';
      } else if (user.roles.some((r) => r.name === 'financial')) {
        mainRole = user.roles.find((r) => r.name === 'financial');
        roleName = 'financial';
      } else {
        // Si no hay roles específicos, tomamos el primero
        mainRole = user.roles[0];
        roleName = mainRole.name || 'default';
      }

      // Asignar menú según el rol encontrado
      this.menuItems = this.menuService.getMenu();

      // Actualizar el rol en el userProfile
      const displayName = mainRole && mainRole.display_name ? mainRole.display_name : roleName;
      this.userProfile = {
        ...this.userProfile,
        role: displayName,
      };
    } else {
      // Si no hay roles, usar menú por defecto
      this.menuItems = this.menuService.getMenu();
      this.userProfile = {
        ...this.userProfile,
        role: 'Recepcionista',
      };
    }
  }

  ngOnDestroy() {
    // Limpiar las suscripciones para evitar fugas de memoria
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }

    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  // Método para navegar a una ruta
  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  // Método para expandir/contraer el menú
  toggleMenu() {
    this.menuExpanded = !this.menuExpanded;
  }

  async logout() {
    try {
      await this.authService.signOut();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  }
}
